import { render, staticRenderFns } from "./MortgageResultsPage.vue?vue&type=template&id=bfec6354&scoped=true"
import script from "./MortgageResultsPage.vue?vue&type=script&lang=js"
export * from "./MortgageResultsPage.vue?vue&type=script&lang=js"
import style0 from "./MortgageResultsPage.vue?vue&type=style&index=0&id=bfec6354&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfec6354",
  null
  
)

export default component.exports